var STATES = {
  HOVER: "hover",
  FOCUS: "focus"
};
export default STATES;